import classNames from "classnames";
import styles from "./styles/FooterCS.module.scss";
import { observer } from "mobx-react";
import ClickableLink from "../utilities/ClickableLink";
import FontAwesome from "../utilities/FontAwesome";
import { useUserMenuLinks } from "../header/UserDropDownMenu";
import { TranslatedText } from "../utilities/TranslatedText";

const adminColumnClassName = classNames({
  [styles.adminColumn]: true,
});

const FooterAccountColumn = observer(() => {
  const schoolBlocksAdminLinks = useUserMenuLinks();

  let links = schoolBlocksAdminLinks.map((l, i) => (
    <li key={i}>
      {l.onClick ? (
        <button
          onClick={() => {
            l.onClick?.();
          }}
        >
          <span className={classNames(l.icon, styles.icon)} />
          <span>{l.title}</span>
        </button>
      ) : (
        <ClickableLink
          title={typeof l.title === "string" ? l.title : undefined}
          href={l.path}
        >
          <FontAwesome ariaHidden={true} name={l.icon} /> {l.title}
        </ClickableLink>
      )}
    </li>
  ));

  return (
    <div className={adminColumnClassName}>
      <TranslatedText as={"h3"} size={"5"}>
        ACCOUNT
      </TranslatedText>
      <ul>{links}</ul>
    </div>
  );
});

export default FooterAccountColumn;
